import { render, staticRenderFns } from "./OrdersHistory.vue?vue&type=template&id=2f0cc879&scoped=true"
import script from "./OrdersHistory.vue?vue&type=script&lang=js"
export * from "./OrdersHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cc879",
  null
  
)

export default component.exports